// Team members data - placeholder photos and descriptions
// User can replace photos/text later

export const teamMembers = [
  {
    id: "sammy",
    name: "Sammy Felber",
    role: { de: "Geschäftsführer · Eidg. dipl. Maler", en: "CEO · Federally certified painter", fr: "Directeur · Peintre diplômé fédéral", it: "Direttore · Pittore diplomato federale" },
    bio: {
      de: "Inhaber und Gründer. Übernahme des Malergeschäfts im Jahr 2018. Spezialist für anspruchsvolle Spachteltechniken und Denkmalpflege.",
      en: "Owner and founder. Took over the painting business in 2018. Specialist in demanding stucco techniques and heritage care.",
      fr: "Propriétaire et fondateur. Reprise de l'entreprise en 2018. Spécialiste des techniques de stuc exigeantes et du patrimoine.",
      it: "Proprietario e fondatore. Rilevamento dell'azienda nel 2018. Specialista in tecniche di stucco e beni culturali.",
    },
    photo: null,
    initials: "SF",
  },
  {
    id: "mitarbeiter-1",
    name: "Team Mitglied",
    role: { de: "Vorarbeiter Maler", en: "Foreman painter", fr: "Chef d'équipe peintre", it: "Capomastro pittore" },
    bio: { de: "Erfahrener Maler mit Fokus auf Innenarbeiten und Tapezierarbeiten.", en: "Experienced painter focusing on interior work and wallpapering.", fr: "Peintre expérimenté spécialisé en travaux intérieurs.", it: "Pittore esperto specializzato in lavori interni." },
    photo: null,
    initials: "TM",
  },
  {
    id: "mitarbeiter-2",
    name: "Team Mitglied",
    role: { de: "Fassadenspezialist", en: "Facade specialist", fr: "Spécialiste façades", it: "Specialista facciate" },
    bio: { de: "Spezialist für Fassadensanierung, Wärmedämmung und Aussenarbeiten.", en: "Specialist in facade renovation, insulation and exterior work.", fr: "Spécialiste rénovation de façades, isolation et travaux extérieurs.", it: "Specialista in risanamento facciate, isolamento e lavori esterni." },
    photo: null,
    initials: "TM",
  },
  {
    id: "mitarbeiter-3",
    name: "Team Mitglied",
    role: { de: "Gipser / Trockenbau", en: "Plasterer / Drywall", fr: "Plâtrier / Cloisons sèches", it: "Gessista / Cartongesso" },
    bio: { de: "Verantwortlich für Putzarbeiten, Trockenbau und Spachtelarbeiten.", en: "Responsible for plastering, drywall and finishing work.", fr: "Responsable des travaux de crépi, cloisons sèches et stuc.", it: "Responsabile per intonaco, cartongesso e stuccatura." },
    photo: null,
    initials: "TM",
  },
  {
    id: "mitarbeiter-4",
    name: "Team Mitglied",
    role: { de: "Lackierer · Spritzwerkstatt", en: "Lacquerer · Spray workshop", fr: "Laqueur · Atelier de peinture", it: "Verniciatore · Officina" },
    bio: { de: "Spezialist für hochwertige Lackierarbeiten in unserer Spritzwerkstatt.", en: "Specialist in high-end lacquer work in our spray workshop.", fr: "Spécialiste laquage haut de gamme dans notre atelier.", it: "Specialista in verniciatura di alto livello nella nostra officina." },
    photo: null,
    initials: "TM",
  },
];
